
import TableList from "@components/templates/tablelist";
import { HttpGetPayBillList } from "@/service/chargescalc";
import { mapState, mapGetters } from "vuex";
import comExcel from './excelalert'

import mixin from '../mixin'

export default {
    mixins: [TableList,mixin],
    components: {
        comExcel
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
        };
    },
    methods: {
        ajaxRequest: HttpGetPayBillList,

        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "export":
                    this.export();
                    // this.handleWebfs(
                    //     process.env.VUE_APP_APIURL_FBB +
                    //         "/api/v2/billing/adjustmantPayable/exportByBill",
                    //     this.formData,
                    //     {
                    //         executor: "request",
                    //         download: true,
                    //         method: "get",
                    //     }
                    // );
                    break;
            }
        },
        export(){
            const { search }=this.formData
                const startAt = search.BT_createdAt ? search.BT_createdAt.slice(0,10) : `''`
                const endAt = search.BT_createdAt ? search.BT_createdAt.slice(13) : `''`
                const searchItem = {
                    isManage: 1,
                    context_id: global.SYSID,
                    warehouse_id: search.EQ_warehouseId || `''`,
                    bill_no: search.EQ_billNo || `''`,
                    billing_order_no: search.EQ_billingOrderNo || `''`,
                    type: search.EQ_type || `''`,
                    start_at: startAt,
                    end_at: endAt,
                    bill_status: search.EQ_billStatus || `''`,
                }
                this.handleWebfs(
                    process.env.VUE_APP_APIURL_BI + "/api/v1/ReportTask/save",
                    {args:JSON.stringify(searchItem), template_id: 10015},
                    {
                        executor: "request",
                        download: true,
                        method: "post",
                    }
                )
                .then((res) => {
                    this.operate = {
                      title: '查询条件导出',
                      show: true,
                      width: 560,
                      component: "comExcel",
                      fileId: res.data.id,
                      showFooter: false
                }})
                .catch((err) => {
                    // this.$VMessage.error(err.message);
                });
        },
    },
    computed: {
        ...mapGetters('dictionary',['getBillcusorgList','getBillcusWareList','getCusproductList','getCusBillTypeList']),
        ToolsData(){
            return [
                {
                    name: "导出",
                    operate: "export",
                    theme: "primary",
                },
            ]

        },
        SearchsData() {
            let widthStyle = 'width: 200px;'
            return  [
                {
                    label: "仓库",
                    tag: 'vSelect',
                    key: "EQ_warehouseId",
                    show:true,
                    options:this.warehouseList,
                    props:{
                        filterable:true,
                    }
                },

                {
                    label: '账单编号',
                    tag: 'vInput',
                    key: 'EQ_billNo',
                    show: true,
                },
                {
                    label: '调账类型',
                    tag: 'vSelect',
                    key: 'EQ_type',
                    options: [
                        {value:1,label:'调账返还'},
                        {value:0,label:'调账扣减'}
                    ],
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' }),
                    key: 'EQ_billingOrderNo',
                    tag: 'Input',
                    style: widthStyle
                },
                {
                    label: '创建日期',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props:{
                        options: this.options,
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle,
                },


            ]
        },
        columns() {
            return  [
                {
                    title: '仓库',
                    render:(h,{row})=>{
                        const result= this.warehouseList.filter(item => item.value === row.warehouseId )
                        return result[0]?result[0].label:'--'
                    }
                },
                {
                    title: '账单编号',
                    render: (h, { row }) => {
                        return <div>{row.billNo || '--'}</div>
                    }
                },
                {
                    title: '账期范围',
                    render: (h, { row }) => {
                        return <div>
                         <div>{row.billStartTime || '--'} '~' {row.billEndTime || '--'}</div>
                        </div>

                    },
                },
                {
                    title: '账期描述',
                    render: (h, { row }) => {
                        return <div>{row.billRemark || '--'}</div>
                    }
                },
                {
                    title: '账期状态',
                    render: (h, { row }) => {
                        return <div>{row.billStatus == 0 ? '未关账':'已关账' || '--'}</div>
                    }
                },
                {
                    title: '调账类型',
                    render: (h, { row }) => {
                        return <div>{row.type == 0 ? '调账扣减':'调账返还' || '--'}</div>
                    }
                },
                {
                    title: '调账金额',
                    render: (h, { row }) => {
                        return <div>{row.amount || '--'}</div>
                    }
                },
                {
                    title: '币种',
                    render: (h, { row }) => {
                        return <div>{row.currency || '--'}</div>
                    }
                },
                {
                    title: this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' }),
                    render: (h, { row }) => {
                        return <div>{row.billingOrderNo || '--'}</div>
                    }
                },
                {
                    title: '费用类型',
                    render:(h,{row})=>this.findRenderLabel(this.getCostType, row.billingType)
                    // render: (h, { row }) => {
                    //     return <div>{row.billingType || '--'}</div>
                    // }
                },
                {
                    title: '调账说明',
                    render: (h, { row }) => {
                        return <div>{row.remark || '--'}</div>
                    }
                },
                {
                    title: '创建时间',
                    render: (h, { row }) => {
                        return <div>{row.createdAt || '--'}</div>
                    }
                },
            ];
        },

    },

};
